{
  "timetable": {
    "panel": {
      "title": "Aikataulu",
      "departure": "Meno",
      "return": "Paluu",
      "bookFlights": "Varaa lennot"
    },
    "flightList": {
      "selectDepartureDate": "Valitse lähtöpäivä, niin näet aikataulun.",
      "selectReturnDate": "Valitse paluupäivä, niin näet aikataulun."
    }
  }
}
